(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-most-popular.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-most-popular.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverToplistsMostPopular = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receiver_toplists_most_popular(data);
    },

    regions: {
      toplistsMostPopular: '.js-receiver-toplists-most-popular'
    },
    events: {
      'click .js-fetch-more': 'fetchMore'
    },
    collectionEvents: {
      change: 'render'
    },

    tagName: 'div',
    className: 'most-popular-wrapper',

    onRender: function() {
      this.getRegion('toplistsMostPopular').show(new svs.grassroots.views.ReceiverToplistsMostPopularList({
        collection: this.options.collection
      }));
    },
    fetchMore: function() {
      var offset = this.model.get('offsetSupporters');
      this.model.set('offsetSupporters', offset + 10);
      svs.ui.loader.show();
      this.collection.fetchMoreItems(2, offset);
    }
  });
})(Backbone, _, svs);


 })(window);